export const useIsPreview = () => {
 if (typeof window !== "undefined") {
   return window.top !== window;
 }
 return false;
};
